jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        var autoc_cache = {};

        if ($('.suggest_address').length> 0) {
            $.each($('input.suggest_address'), function(e){
                scAddressAutocomplete($(this).attr('id'));
            });
        }

        function scAddressAutocomplete(id) {
            if (id != undefined && $('#'+id).length> 0) {
                 // console.log('scAddressAutocomplete(#'+id+')');
                $( '#'+id ).autocomplete({
                    minLength: 5,
                    source: function( request, response ) {
                        var term = request.term;
                        if ( term in autoc_cache ) {
                            response( autoc_cache[ term ] );
                            console.log(autoc_cache[ term ]);
                            return;
                        }
                        request.action = 'sc_address_search';
                        request._ajax_nonce = $('#address_search_referer').val();

                        $.getJSON( ajax_url, request, function( data, status, xhr ) {
                            autoc_cache[ term ] = data;
                            response( data );
                        });
                    },
                    select: function( event, ui ) {
                        var section_name = id.replace('_address_1', '');

                        var request = {};
                        request.action = 'sc_get_place';
                        request._ajax_nonce = $('#address_search_referer').val();
                        request.term = ui.item.place_id;

                        $('.ui-autocomplete.ui-widget').remove();

                        $.getJSON( ajax_url, request, function( data, status, xhr ) {
                           //  console.log(data);
                            if (data['line_1'] != undefined && data['line_1'] != '') {
                                $( '#address1').val( data['line_1'] );
                                $( '#city').val( data['town_or_city'] );
                                $( '#postcode').val( data['postcode'] );
                                $( '#country').val( data['country'] );
                            }
                        });

                        return false;
                    }
                });
            }
        }



        //Document Ready ENDS
    });
})(jQuery);